export default __webpack_public_path__ + "static/media/logo dashboard blanco.94fca27a.svg";